type ErrorLike = {
  code?: string | null;
  message?: string | null;
  details?: string | null;
};

export function isMissingSupabaseEntityError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;

  const e = error as ErrorLike;
  const code = e.code ?? "";
  const message = e.message ?? "";
  const details = e.details ?? "";
  const haystack = `${message} ${details}`.toLowerCase();

  return (
    code === "PGRST202" ||
    code === "PGRST205" ||
    haystack.includes("schema cache") ||
    haystack.includes("could not find the table") ||
    haystack.includes("could not find the function")
  );
}
